import { styled } from 'styled-components'
import WizrText from '../WizrText'
import WizrButton from '../WizrButton'
import WizrFlexSpacing from '../WizrFlexSpacing'

interface ILogoutConfirm {
  onLogoutConfirm?: () => void
  onCancel?: () => void
}

const StyledFlexSpacing = styled(WizrFlexSpacing)`
  .ant-space-item:last-child {
    width: 100% !important;
    align-self: stretch !important;
  }
`

const TextContainer = styled.div`
  background: #fff;
  text-align: left;
  width: 100%;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: auto;
  padding: 15px 15px 0px 15px;
  width: 100%;
  box-sizing: border-box;
`
const LogoutConfirm = ({ onLogoutConfirm, onCancel }: ILogoutConfirm): JSX.Element => {
  return (
    <StyledFlexSpacing background='#FFF' textAlign='left' alignItems='flex-start'>
      <TextContainer>
        <WizrText type='body1'>Are you sure you want to logout ?</WizrText>
      </TextContainer>
      <ButtonContainer>
        <WizrButton type='default' text='Logout' onClick={onLogoutConfirm} style={{ borderRadius: '20px' }} />
        <WizrButton text='Cancel' onClick={onCancel} style={{ borderRadius: '20px' }} />
      </ButtonContainer>
    </StyledFlexSpacing>
  )
}

export default LogoutConfirm
